import React, { useState } from "react";
import { Typography } from "antd";
import {
  addCatalogSurgeryStoryContent,
  getAllCatalogSurgeryStories,
} from "../../../../store/actions";
import { connect } from "react-redux";
import PhotosCopy from "./PhotosCopy";
import { ATMED_VENDOR_CATALOG_SURGERY_STORIES } from "../../../../common/awsBucket";

const { Link } = Typography;
const EditVendorEquipmentButton = ({ columnData, categoryId, story }) => {
  const [imagemodalVisible, setimageModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const showImageModal = async () => {
    setimageModalVisible(true);
  };
  const hideImageModal = () => {
    setimageModalVisible(false);
  };

  const addPhoto = async (data) => {
    const payloadObj = {
      surgery_story_id: story.id,
      surgery_id: categoryId,
      payload: {
        surgery_story_content: { url: data, media: "photo", status: true },
      },
    };

    await addCatalogSurgeryStoryContent(payloadObj);
    setTimeout(
      () => getAllCatalogSurgeryStories(undefined, 20, currentPage),
      1000
    );
  };

  return (
    <>
      <PhotosCopy
        data={story}
        categoryId={categoryId}
        onCancel={hideImageModal}
        visible={imagemodalVisible}
        title={`${columnData.title} - ${story.title}`}
        submitText="Update content"
        addPhoto={addPhoto}
        uploadBucketName={ATMED_VENDOR_CATALOG_SURGERY_STORIES}
      />

      <div>
        <Link onClick={showImageModal} className="link-button">
          {story.content.length} Items
        </Link>
      </div>
    </>
  );
};

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  // story: vendorEquipmenReducer.story,
  allEquipmentCategories: vendorEquipmenReducer.allEquipmentCategories,
});
export default connect(mapStateToProps)(EditVendorEquipmentButton);
